import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';

import './styles.css';

function Categories(props) {
  return (
    <Container>
      <ul className={'categories clearfix'}>
        {props.content &&
          props.content.map((col, index) => {
            if (col.slug === 'all') return null;
            return (
              <li
                key={index}
                className={'fadeIn animated'}
                style={{
                  animationDelay: `0.${index}s`,
                  animationDuration: `.6s`,
                }}
              >
                <Link
                  to={`/${props.language}/${props.contentType}/types/${
                    col.slug
                  }`}
                  className={
                    props.currentCattegory === col.slug ? 'active' : 'notactive'
                  }
                >
                  <span
                    className={'catImage'}
                    style={{
                      backgroundImage: `url(${col.image.src})`,
                    }}
                  />
                  {col.name}
                </Link>
              </li>
            );
          })}
      </ul>
    </Container>
  );
}

export default Categories;
